import { render, staticRenderFns } from "./ShopifyUtilities.vue?vue&type=template&id=5825c6c7"
import script from "./ShopifyUtilities.vue?vue&type=script&lang=js"
export * from "./ShopifyUtilities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports